import Vue from 'vue';
import VueRouter from 'vue-router';
import auth from '@/Data/Functions/auth';
import buildRoutes from '@/router/routes';

Vue.use(VueRouter);

/**
 * This creates the router object, imported into the root of the app.
 */
const router = new VueRouter({
    /**
     * Declare all the available route components for the App.
     * Error404 must be declared last.
     */
    routes: buildRoutes()
});

/**
 * Navigation guards for authentication
 */
router.beforeEach((to, _, next) => {
    const pathToRedirect = to.fullPath === '/login' ? '/' : to.fullPath;
    const pathRequiresAuth = to.matched.some(record => record.meta.securityLevelRequired.length > 0);
    const isSuperUserPage = to.matched.some(record => (record.meta.superUsersOnly ? record.meta.superUsersOnly : false));

    if (pathRequiresAuth) {
        if (auth.status() === false) {
            next({
                path: '/login',
                query: { redirect: pathToRedirect }
            });
        }
        else {
            const user = auth.userinfo();
            const userCanAccessPage = to.matched.some(record => record.meta.securityLevelRequired.some(s => s === user.userinfo.securityLevelName));

            if (userCanAccessPage) {
                const superUserLoggedIn = auth.superStatus();

                if (isSuperUserPage) {
                    if (superUserLoggedIn) {
                        next();
                    }
                    else {
                        next({
                            path: '/super-users',
                            query: { redirect: pathToRedirect }
                        });
                    }
                }
                else {
                    next();
                }
            }
            else {
                next({
                    path: '/'
                });
            }
        }
    }
    else if (auth.status() === true && to.path === '/login') {
        /* Trying to navigate to login page whilst auth'd, redirect to homepage */
        if (to.query.redirect) {
            next(to.query.redirect);
        }
        else {
            next();
        }
    }
    else {
        /* Page doesn't require auth, progress to desired page */
        next();
    }
});

export default router;
